import { sprintf } from '@gravityforms/utils';
import elements from './elements';

/**
 * @function setProgressBar
 * @description Sets the progress bar HTML based on the active step.
 *
 * @since 1.0.0
 *
 * @param {number} currentStep The current step number.
 * @param {number} totalSteps  The total number of steps.
 */
export const setProgressBar = ( currentStep, totalSteps ) => {
	// Cannot divide by 0, return early.
	if ( ! totalSteps ) {
		return;
	}

	const { label = '' } = elements.progressBarLabel.dataset;

	const percentage = Math.floor( ( ( currentStep - 1 ) / totalSteps ) * 100 );
	elements.progressBarInner.style.inlineSize = `${ percentage }%`;

	//const str = sprintf('My name is %1$s %2$s. I am %3$i years old.', 'Joe', 'Doe', 30);

	if ( elements.progressBar.dataset.jsProgressionType === 'percentage' ) {
		const step = `${ percentage }%`;
		elements.progressBarLabel.innerHTML = sprintf( label, step );
	}

	if ( elements.progressBar.dataset.jsProgressionType === 'proportion' ) {
		const step = `${ currentStep - 1 }/${ totalSteps }`;
		elements.progressBarLabel.innerHTML = sprintf( label, step );
	}
};
